import { makeStyles } from '@material-ui/core/styles';

export const filterContainerHeight = 56;

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,

        '&.MuiToolbar-root': {
            position: 'unset',
        },

        '&.MuiToolbar-regular': {
            minHeight: filterContainerHeight,
            paddingLeft: 20,
            paddingRight: 20,
        },

        '& > .MuiIconButton-root': {
            padding: theme.spacing(1),
            marginRight: theme.spacing(1),
        },

        '@media print': {
            display: 'none',
        },
    },

    dialogTitle: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.alignItemsCenter,
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
    },

    dialogTitleText: {
        ...theme.mixins.flex.grow(1),
    },

    dialogCloseButton: {
        ...theme.mixins.flex.grow(0),
        marginLeft: theme.spacing(1),
    },

    filterContainer: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.alignItemsCenter,
        ...theme.mixins.flex.flexWrapWrap,
        minHeight: filterContainerHeight,
        paddingBottom: theme.spacing(0.5),
    },

    summaryInfo: {
        ...theme.mixins.flex.displayInlineFlex,
        ...theme.mixins.flex.alignItemsCenter,
        marginLeft: theme.spacing(0.5),
        '& svg': {
            color: theme.palette.info.main,
            width: theme.spacing(2),
            height: theme.spacing(2),
        },
    },

    filter: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        marginRight: 24,
        marginBottom: theme.spacing(0.5),
    },

    filterSummary: {
        cursor: 'pointer',
        display: 'inline-block',
    },

    filterLabel: {
        fontSize: 10.4,
    },

    filterValue: {
        ...theme.mixins.flex.displayFlex,
        fontSize: 14,
        borderBottom: `1px solid ${theme.palette.divider}`,

        '& span': {
            ...theme.mixins.flex.grow(1),
            whiteSpace: 'nowrap',
        },
    },

    filterButton: {
        margin: '18px 0 0 6px',
        padding: 0,

        '&:hover': {
            backgroundColor: 'inherit',
        },

        '& svg': {
            fontSize: '1rem',
        },
    },
}));

export default useStyles;
